/*
    this component was already existing in the codebase,
    we've made changes into it so we can reuse it on the new search overview page
    after we will finish the migration we can remove the old component
    and move this one to the correct location
*/

import styled from "styled-components";

import { colorsPalettes, rgba, setFont } from "@similarweb/styles";
import { Box, Title } from "@similarweb/ui-components";

import { ChartLoaderContainer } from "pro-features/components/Loaders/src/ExpandedTableRowLoader/StyledComponents";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const maxMediaScreenSize = "1440px";
const { carbon } = colorsPalettes;

export const ButtonsContainer = styled.div`
    grid-column: 2;
    display: flex;
    justify-content: space-between;
    @media (max-width: ${maxMediaScreenSize}) {
        grid-column: 1;
    }
`;

const SitesChartLoaderContainer: any = styled(ChartLoaderContainer)`
    width: 100%;
    box-sizing: border-box;
`;

const StyledHeader: any = styled(FlexColumn)`
    height: 70px;
    padding-top: 24px;
    padding-left: 24px;
`;

export const FiltersRowContainer = styled(FlexRow)`
    justify-content: space-between;
    margin-bottom: 16px;
`;

export const FiltersRowStyle = styled.div`
    display: flex;
    align-items: center;
    > div {
        width: auto;
    }
`;

export const FiltersTitle = styled.div`
    ${setFont({ $size: 14, $color: carbon[400] })};
    margin-right: 12px;
`;

const ChartContainer = styled.div`
    box-sizing: border-box;
    padding: 0 14px 8px 14px;
    width: calc(100% - 240px);
`;

const LegendsContainer = styled.div`
    padding-top: 8px;
    width: 240px;
    padding-right: 16px;
`;

const StyledBox = styled(Box)`
    width: 100%;
    height: 554px;
`;

export const SearchOverviewGraphHeaderStyle = styled(FlexRow)<{ marginBottom: number }>`
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    ${({ marginBottom }) => `margin-bottom:${marginBottom}`}
    align-items: center;
`;

export const ChipDownContainer = styled.div`
    width: auto;
    display: inline-flex;
    margin-right: 8px;
`;

export const SearchOverviewGraphContainer = styled.div`
    background-color: white;
    box-shadow: 0 3px 6px 0 ${rgba(colorsPalettes.carbon[500], 0.08)};

    .react-tabs ul {
        margin-bottom: 24px;
    }
`;

const TabsContainer: any = styled.div`
    flex-grow: 1;
    flex-basis: 100%;
    .sitesVsCategory {
        text-transform: uppercase;
        padding-bottom: 9px;
        border-bottom: 1px solid ${carbon["100"]};
    }
`;

export const TabContentStyle = styled.div`
    padding: 0 16px;
    box-sizing: border-box;
    flex-grow: 1;
    border-bottom: 1px solid ${carbon["50"]};
`;

const CtaWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    background-color: white;
`;

export const StyledHeaderTitle = styled(Title).attrs<{ "data-automation-box-title"?: boolean }>((props) => ({
    "data-automation-box-title": true,
}))`
    font-size: 20px;
    padding: 19px 24px;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 6px;
`;

export const UtilitiesContainer = styled.div`
    display: flex;
`;

export const UtilitiesContainerWrapper = styled.div`
    padding: 11px 20px;
`;

export const MMXAlertWrapper = styled.div`
    align-self: center;
    margin-top: 2px;
    margin-left: 2px;
`;

export const SwitchersContainer = styled(FlexRow)`
    margin-left: auto;
    margin-right: 16px;
    gap: 12px;
`;
